export const ELOQUA_PREPOP_REQUEST = "ELOQUA_PREPOP_REQUEST";
export const ELOQUA_PREPOP_SUCCESS = "ELOQUA_PREPOP_SUCCESS";
export const ELOQUA_PREPOP_FAILURE = "ELOQUA_PREPOP_FAILURE";
